<template>
  <a @click="goBack">
      <img
      :src="backicon"
      width="20"
      />
  </a>
</template>

<script>
export default {
    data() {
        return {
            backicon: require("@/assets/img/SVG/BackButton.svg")
        }
    },
    methods: {
      goBack() {
        window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
      },
    }
}
</script>

<style>

</style>
